(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["workstoak_V34_B2BSTATUS_A"] && !Shopify.designMode) return;
  try {
    (function () {
  var workstoakJumpToken = 0;

  function initWorkstoakSelection(root) {
    if (!root || root.dataset.workstoakReady === 'true') return;
    root.dataset.workstoakReady = 'true';

    var matrix = root.querySelector('[data-workstoak-matrix]');
    var toggle = root.querySelector('[data-workstoak-toggle]');
    var totalElement = root.querySelector('[data-workstoak-total]');
    var cartButton = root.querySelector('[data-workstoak-cart]');
    var message = root.querySelector('[data-workstoak-message]');
    var colorButtons = root.querySelectorAll('[data-workstoak-color]');
    var quantities = root.querySelectorAll('[data-workstoak-qty]');
    var unitPriceElement = root.querySelector('[data-workstoak-unit-price]');
    var totalPriceElement = root.querySelector('[data-workstoak-total-price]');
    var subtotalElement = root.querySelector('[data-workstoak-subtotal]');
    var discountRow = root.querySelector('[data-workstoak-discount-row]');
    var discountLabelElement = root.querySelector('[data-workstoak-discount-label]');
    var discountAmountElement = root.querySelector('[data-workstoak-discount-amount]');
    var discountNoteElement = root.querySelector('[data-workstoak-discount-note]');
    var defaultUnitPriceText = unitPriceElement ? unitPriceElement.textContent.trim() : '';
    var productId = root.dataset.productId;
    var currency = root.dataset.currency || 'EUR';
    var locale = root.dataset.locale || 'de';
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Fix 5: stock limits. cartQtyByVariant is filled from /cart.js. */
    var lowStockThreshold = parseInt(root.dataset.lowStock, 10);
    if (isNaN(lowStockThreshold) || lowStockThreshold < 0) lowStockThreshold = 0;
    var cartQtyByVariant = {};

    /* Fix 3: B2B tier state. Tiers come from the block settings. */
    var b2bStatus = root.querySelector('[data-workstoak-b2b-status]');
    var b2bTiers = [];
    var b2bTiersElement = root.querySelector('[data-workstoak-b2b-tiers]');
    if (b2bTiersElement) {
      try { b2bTiers = JSON.parse(b2bTiersElement.textContent || '[]'); } catch (e) { b2bTiers = []; }
    }
    b2bTiers = (b2bTiers || []).filter(function (tier) {
      return tier && Number(tier.threshold) > 0 && Number(tier.percent) > 0;
    }).map(function (tier) {
      return { threshold: Number(tier.threshold), percent: Number(tier.percent) };
    }).sort(function (a, b) { return a.threshold - b.threshold; });
    var b2bCartValue = 0;
    var b2bCartDiscount = 0;
    var b2bPending = 0;

    /* ---------------------------------------------------------------
     * Fix 6/7: gallery jump.
     * The gallery always shows all images in a fixed, color-grouped order
     * (hide_variants = false, fixed order in product-media-gallery-content).
     * A color click jumps the big image to that color's variant image.
     * Primary source: the variant's featured media id (data-media-id on the
     * color button). Fallback: filename match with word boundaries.
     * ------------------------------------------------------------- */
    var galleryConfigElement = document.querySelector('[data-workstoak-gallery-config]');
    var galleryConfig = { media: [] };
    if (galleryConfigElement) {
      try { galleryConfig = JSON.parse(galleryConfigElement.textContent || '{}'); } catch (e) {}
    }

    /*
     * Fix 7: Horizon replaces the whole <media-gallery> on every variant
     * change with a freshly rendered one that starts at the first image.
     * That caused the jump "right image -> first image -> right image".
     * Since the gallery is identical for every variant, we remove the new
     * gallery from the incoming HTML before Horizon's gallery handler runs
     * (capture phase on document runs before the section listener).
     * Every other part of the variant update (price, buttons, sticky bar)
     * is untouched.
     */
    document.addEventListener('variant:update', function (event) {
      var data = event && event.detail && event.detail.data;
      if (!data || !data.html || data.newProduct) return;
      if (String(data.productId) !== String(productId)) return;
      if (!document.querySelector('media-gallery')) return;
      var incoming = data.html.querySelector && data.html.querySelector('media-gallery');
      if (incoming) incoming.remove();
    }, true);

    function normalizeGalleryKey(value) {
      return String(value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/&/g, 'and')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function findMediaIdByFilename(key) {
      if (!key) return '';
      var needle = '-' + key + '-';
      var media = (galleryConfig.media || []).find(function (entry) {
        return ('-' + normalizeGalleryKey(entry.filename) + '-').indexOf(needle) !== -1;
      });
      return media ? String(media.id) : '';
    }

    function getFallbackMediaIdForColor(colorName) {
      var full = normalizeGalleryKey(String(colorName || '').replace(/\//g, ' '));
      var primary = normalizeGalleryKey(String(colorName || '').split('/')[0]);
      return findMediaIdByFilename(full) || findMediaIdByFilename(primary);
    }

    function getColorButton(colorName) {
      return Array.prototype.find.call(colorButtons, function (button) {
        return button.dataset.workstoakColor === colorName;
      }) || null;
    }

    function getTargetMediaId(colorName) {
      var button = getColorButton(colorName);
      var id = button ? String(button.dataset.mediaId || '') : '';
      return id || getFallbackMediaIdForColor(colorName);
    }

    function getMediaId(element) {
      var media = element.matches && element.matches('[data-media-id]') ? element : element.querySelector('[data-media-id]');
      return media ? String(media.getAttribute('data-media-id') || '') : '';
    }

    function getSlideshowElement() {
      return document.querySelector('media-gallery slideshow-component');
    }

    function getAllSlideshowSlides(slideshow) {
      if (!slideshow) return [];
      return Array.prototype.slice.call(
        slideshow.querySelectorAll('slideshow-slides > slideshow-slide')
      );
    }

    function getGalleryScroller(slideshow) {
      return slideshow ? slideshow.querySelector('slideshow-slides[ref="scroller"]') || slideshow.querySelector('slideshow-slides') : null;
    }

    function scrollToGallerySlide(slide, animate) {
      if (!slide) return;
      var scroller = getGalleryScroller(getSlideshowElement());
      if (!scroller) return;
      scroller.scrollTo({
        left: slide.offsetLeft,
        behavior: animate && !reduceMotion ? 'smooth' : 'auto'
      });
    }

    function getScrollableParent(element) {
      var node = element ? element.parentElement : null;
      while (node && node !== document.body) {
        if (node.scrollWidth > node.clientWidth + 1) return node;
        node = node.parentElement;
      }
      return null;
    }

    /* Keeps the active thumbnail in view inside the thumbnail strip. */
    function syncThumbnailStrip(index, animate) {
      var thumbnails = document.querySelectorAll('media-gallery .slideshow-controls__thumbnail');
      var thumbnail = thumbnails[index];
      if (!thumbnail) return;
      var strip = getScrollableParent(thumbnail);
      if (!strip) return;
      var target = thumbnail.offsetLeft - (strip.clientWidth / 2) + (thumbnail.offsetWidth / 2);
      strip.scrollTo({ left: Math.max(0, target), behavior: animate && !reduceMotion ? 'smooth' : 'auto' });
    }

    function jumpGalleryToColor(colorName, animate) {
      var mediaId = getTargetMediaId(colorName);
      if (!mediaId) return false;
      var slideshow = getSlideshowElement();
      var slides = getAllSlideshowSlides(slideshow);
      var index = slides.findIndex(function (slide) { return getMediaId(slide) === mediaId; });
      if (index < 0) return false;
      var scroller = getGalleryScroller(slideshow);
      if (scroller && Math.abs(scroller.scrollLeft - slides[index].offsetLeft) < 2) {
        syncThumbnailStrip(index, false);
        return true;
      }
      scrollToGallerySlide(slides[index], animate);
      syncThumbnailStrip(index, animate);
      return true;
    }

    /*
     * Jumps right away. Safety net: should Horizon still replace the gallery
     * element (e.g. another code path), jump again instantly as soon as the
     * new element is in the DOM (MutationObserver runs before the next paint).
     * A newer click or manual browsing cancels older pending jumps.
     */
    function jumpGalleryAfterHorizonChange(colorName, animate) {
      var token = ++workstoakJumpToken;
      jumpGalleryToColor(colorName, animate);

      var gallery = document.querySelector('media-gallery');
      var parent = gallery ? gallery.parentElement : null;
      if (!parent) return;

      var observer = new MutationObserver(function () {
        if (token !== workstoakJumpToken) {
          observer.disconnect();
          return;
        }
        var current = document.querySelector('media-gallery');
        if (!current || current === gallery) return;
        observer.disconnect();
        jumpGalleryToColor(colorName, false);
        bindGalleryArrows();
      });
      observer.observe(parent, { childList: true });
      window.setTimeout(function () { observer.disconnect(); }, 3000);
    }

    function getCurrentSlideIndex(slides, scroller) {
      if (!slides.length || !scroller) return 0;
      var center = scroller.scrollLeft + scroller.clientWidth / 2;
      var best = 0;
      var bestDistance = Infinity;
      slides.forEach(function (slide, index) {
        var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        var distance = Math.abs(slideCenter - center);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = index;
        }
      });
      return best;
    }

    /* Arrows on the big image; browsing never changes the selected color. */
    function bindGalleryArrows() {
      var slideshow = getSlideshowElement();
      if (!slideshow) return;
      var container = slideshow.querySelector('slideshow-container');
      if (!container) return;

      var arrows = container.querySelector('.workstoak-direct-gallery-arrows');
      if (!arrows) {
        arrows = document.createElement('div');
        arrows.className = 'workstoak-direct-gallery-arrows';
        arrows.innerHTML =
          '<button type="button" class="workstoak-direct-gallery-arrow workstoak-direct-gallery-arrow--prev" aria-label="Vorheriges Bild">‹</button>' +
          '<button type="button" class="workstoak-direct-gallery-arrow workstoak-direct-gallery-arrow--next" aria-label="Nächstes Bild">›</button>';
        container.appendChild(arrows);
      }

      var prev = arrows.querySelector('.workstoak-direct-gallery-arrow--prev');
      var next = arrows.querySelector('.workstoak-direct-gallery-arrow--next');
      if (!prev || !next || arrows.dataset.bound === 'true') return;
      arrows.dataset.bound = 'true';

      function move(direction, event) {
        event.preventDefault();
        event.stopPropagation();
        workstoakJumpToken++; /* manual browsing cancels pending color jumps */
        var currentSlideshow = getSlideshowElement();
        var scroller = getGalleryScroller(currentSlideshow);
        var slides = getAllSlideshowSlides(currentSlideshow);
        if (!scroller || slides.length < 2) return;
        var current = getCurrentSlideIndex(slides, scroller);
        var target = direction === 'next'
          ? (current + 1) % slides.length
          : (current - 1 + slides.length) % slides.length;
        scrollToGallerySlide(slides[target], true);
        syncThumbnailStrip(target, true);
      }

      prev.addEventListener('click', function (event) { move('prev', event); });
      next.addEventListener('click', function (event) { move('next', event); });
    }

    function markSelectedColor(name) {
      colorButtons.forEach(function (button) {
        button.setAttribute('aria-pressed', button.dataset.workstoakColor === name ? 'true' : 'false');
      });
    }

    function selectNativeColor(name) {
      var nativePicker = document.querySelector('variant-picker[data-product-id="' + productId + '"]');
      if (!nativePicker) return;
      var fieldsets = nativePicker.querySelectorAll('[data-fieldset-index]');
      if (!fieldsets.length) return;
      var firstFieldset = fieldsets[0];
      var button = getColorButton(name);
      var option = null;

      if (button && button.dataset.optionValueId) {
        option = firstFieldset.querySelector('[data-option-value-id="' + button.dataset.optionValueId + '"]');
      }

      if (!option) {
        option = Array.prototype.slice.call(
          firstFieldset.querySelectorAll('input, select, option')
        ).find(function (element) {
          return (element.value || element.textContent || '').trim() === name;
        });
      }

      if (!option) return;
      if (option.tagName === 'OPTION') {
        option.selected = true;
        option.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (!option.checked) {
        option.click();
      }
    }

    function setSelectedColor(name, options) {
      options = options || {};
      markSelectedColor(name);
      /* Jump first, then let Horizon update the variant in the background. */
      jumpGalleryAfterHorizonChange(name, options.animate === true);
      if (options.clickNative !== false) selectNativeColor(name);

      root.dispatchEvent(new CustomEvent('workstoak:color-change', {
        bubbles: true,
        detail: { color: name }
      }));
    }

    /* Fix 1: currency-aware money formatting (amounts in cents). */
    function formatWorkstoakMoney(cents) {
      var amount = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(amount);
      } catch (e) {
        return amount.toFixed(2).replace('.', ',') + ' €';
      }
    }

    /* Fix 3: short format without ,00 for round thresholds (e.g. "250 €"). */
    function formatWorkstoakMoneyShort(cents) {
      var value = Number(cents || 0);
      var amount = value / 100;
      var digits = value % 100 === 0 ? 0 : 2;
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency, minimumFractionDigits: digits, maximumFractionDigits: digits }).format(amount);
      } catch (e) {
        return amount.toFixed(digits).replace('.', ',') + ' €';
      }
    }

    /*
     * Fix 5: stock limits per matrix field.
     * data-max is only set when Shopify tracks inventory AND overselling is
     * not allowed. Quantities already in the cart are subtracted, so the
     * customer can never request more than is actually available.
     */
    function getBaseMax(input) {
      var raw = input.dataset.max;
      if (raw === undefined || raw === '') return Infinity;
      var value = parseInt(raw, 10);
      return isNaN(value) ? Infinity : Math.max(0, value);
    }

    function getEffectiveMax(input) {
      var base = getBaseMax(input);
      if (base === Infinity) return Infinity;
      return Math.max(0, base - (cartQtyByVariant[String(input.dataset.variantId)] || 0));
    }

    function getStockHint(input) {
      var cell = input.closest('td');
      return cell ? cell.querySelector('[data-workstoak-stock]') : null;
    }

    function renderStockHint(input, capped) {
      var hint = getStockHint(input);
      if (!hint) return;
      var effective = getEffectiveMax(input);
      var inCart = cartQtyByVariant[String(input.dataset.variantId)] || 0;

      hint.classList.toggle('is-warning', !!capped);

      if (effective === Infinity) {
        hint.textContent = '';
      } else if (effective === 0) {
        hint.textContent = inCart > 0 ? 'alle im Warenkorb' : 'ausverkauft';
      } else if (capped) {
        hint.textContent = 'max. ' + effective;
      } else if (lowStockThreshold > 0 && effective <= lowStockThreshold) {
        hint.textContent = 'noch ' + effective;
      } else {
        hint.textContent = '';
      }
    }

    function applyQuantityLimit(input, announce) {
      var effective = getEffectiveMax(input);

      if (effective === Infinity) {
        input.removeAttribute('max');
      } else {
        input.max = String(effective);
      }

      input.disabled = effective === 0;
      if (effective === 0) input.value = 0;

      var value = parseInt(input.value, 10);
      var capped = !isNaN(value) && value > effective;
      if (capped) input.value = effective;

      if (capped) {
        input.classList.add('is-capped');
        window.clearTimeout(input._workstoakCapTimer);
        input._workstoakCapTimer = window.setTimeout(function () {
          input.classList.remove('is-capped');
          renderStockHint(input, false);
        }, 2500);

        if (announce && message) {
          var inCart = cartQtyByVariant[String(input.dataset.variantId)] || 0;
          message.textContent = 'Für ' + input.dataset.color + ' / ' + input.dataset.size +
            ' sind nur noch ' + effective + ' Stück verfügbar' +
            (inCart > 0 ? ' (' + inCart + ' bereits im Warenkorb).' : '.');
        }
      }

      renderStockHint(input, capped || input.classList.contains('is-capped'));
      return capped;
    }

    function applyAllQuantityLimits() {
      quantities.forEach(function (input) { applyQuantityLimit(input, false); });
    }

    function getB2BTierState(value) {
      var current = null;
      var next = null;
      b2bTiers.forEach(function (tier) {
        if (value >= tier.threshold) {
          current = tier;
        } else if (!next) {
          next = tier;
        }
      });
      return { current: current, next: next };
    }

    /*
     * Fix 3: the B2B box is always visible.
     * - Empty cart and no matrix selection: teaser with the first tier.
     * - Otherwise: progress based on cart value + current matrix selection,
     *   so the customer sees live which discount the selection would reach.
     */
    function renderWorkstoakB2B() {
      if (!b2bStatus || !b2bTiers.length) return;

      var valueEl = b2bStatus.querySelector('[data-workstoak-b2b-value]');
      var discountEl = b2bStatus.querySelector('[data-workstoak-b2b-discount]');
      var progressEl = b2bStatus.querySelector('[data-workstoak-b2b-progress]');
      var messageEl = b2bStatus.querySelector('[data-workstoak-b2b-message]');
      var savingEl = b2bStatus.querySelector('[data-workstoak-b2b-saving]');

      var maxPercent = Math.max.apply(null, b2bTiers.map(function (tier) { return tier.percent; }));
      var projected = b2bCartValue + b2bPending;
      var state = getB2BTierState(projected);
      var cartState = getB2BTierState(b2bCartValue);

      b2bStatus.hidden = false;

      b2bStatus.querySelectorAll('[data-tier-threshold]').forEach(function (chip) {
        var threshold = parseInt(chip.dataset.tierThreshold, 10) || 0;
        chip.classList.toggle('is-reached', projected > 0 && projected >= threshold);
        chip.classList.toggle('is-next', projected > 0 && !!state.next && state.next.threshold === threshold);
      });

      if (projected <= 0) {
        var first = b2bTiers[0];
        b2bStatus.dataset.state = 'teaser';
        if (valueEl) valueEl.textContent = 'Ab ' + formatWorkstoakMoneyShort(first.threshold) + ' sparst du automatisch ' + first.percent + ' %';
        if (discountEl) discountEl.textContent = 'bis ' + maxPercent + ' %';
        if (progressEl) progressEl.style.width = '0%';
        if (messageEl) messageEl.textContent = 'Rabatt wird im Warenkorb automatisch abgezogen.';
        if (savingEl) savingEl.textContent = '';
        return;
      }

      b2bStatus.dataset.state = state.next ? 'progress' : 'max';

      if (valueEl) {
        valueEl.textContent = (b2bPending > 0 ? 'Warenkorb + Auswahl: ' : 'Warenkorbwert: ') + formatWorkstoakMoney(projected);
      }

      if (discountEl) discountEl.textContent = (state.current ? state.current.percent : 0) + ' % Rabatt';

      var lower = state.current ? state.current.threshold : 0;
      var progress = 100;
      if (state.next) {
        var range = state.next.threshold - lower;
        progress = range > 0 ? Math.min(100, Math.max(0, ((projected - lower) / range) * 100)) : 0;
      }
      if (progressEl) progressEl.style.width = progress.toFixed(1) + '%';

      var unlockedBySelection = b2bPending > 0 && state.current &&
        (!cartState.current || state.current.percent > cartState.current.percent);

      if (messageEl) {
        if (state.next) {
          messageEl.textContent =
            (unlockedBySelection ? 'Mit deiner Auswahl: ' + state.current.percent + ' % Rabatt. ' : '') +
            'Noch ' + formatWorkstoakMoney(state.next.threshold - projected) + ' bis ' + state.next.percent + ' % Rabatt';
        } else {
          messageEl.textContent = (unlockedBySelection ? 'Mit deiner Auswahl: m' : 'M') +
            'aximaler B2B-Rabatt von ' + maxPercent + ' % erreicht';
        }
      }

      if (savingEl) {
        if (b2bPending > 0) {
          savingEl.textContent = state.current
            ? '≈ ' + formatWorkstoakMoney(Math.round(projected * state.current.percent / 100)) + ' Ersparnis'
            : '';
        } else {
          savingEl.textContent = b2bCartDiscount > 0 ? 'Du sparst ' + formatWorkstoakMoney(b2bCartDiscount) : '';
        }
      }
    }

    /* Reads the cart once and refreshes both the B2B box and the stock limits. */
    async function updateWorkstoakB2BStatus() {
      try {
        var response = await fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store' });
        if (!response.ok) throw new Error('Cart konnte nicht gelesen werden.');
        var cart = await response.json();
        b2bCartValue = Number(cart.original_total_price || 0);
        b2bCartDiscount = Number(cart.total_discount || 0);

        var nextCartQty = {};
        (cart.items || []).forEach(function (item) {
          var key = String(item.variant_id);
          nextCartQty[key] = (nextCartQty[key] || 0) + Number(item.quantity || 0);
        });
        cartQtyByVariant = nextCartQty;
      } catch (error) {
        /* Keep showing the teaser / last known state instead of hiding the box. */
      }
      applyAllQuantityLimits();
      updateTotals();
    }

    /*
     * Fix 1: matrix totals use the real price of every variant (data-price,
     * in cents). The B2B discount itself is still applied by Shopify at cart
     * level, so these are regular prices before the cart discount.
     */
    function updateTotals() {
      var total = 0;
      var totalCents = 0;
      var minUnit = null;
      var maxUnit = null;

      quantities.forEach(function (input) {
        if (input.disabled) return;
        var value = parseInt(input.value, 10);
        if (isNaN(value) || value <= 0) return;
        var price = parseInt(input.dataset.price, 10) || 0;
        total += value;
        totalCents += value * price;
        if (minUnit === null || price < minUnit) minUnit = price;
        if (maxUnit === null || price > maxUnit) maxUnit = price;
      });

      if (totalElement) totalElement.textContent = total;

      /*
       * Fix 8: B2B discount in the matrix summary.
       * Shopify's automatic discounts apply a percentage to the WHOLE cart once
       * its subtotal reaches a tier, so the tier is taken from cart value +
       * current selection. The amounts shown are for the selection only.
       */
      var tierState = getB2BTierState(b2bCartValue + totalCents);
      var percent = totalCents > 0 && tierState.current ? tierState.current.percent : 0;
      /* Shopify rounds the percentage discount DOWN per cart line, so we do too. */
      var discountCents = 0;
      if (percent) {
        quantities.forEach(function (input) {
          if (input.disabled) return;
          var qty = parseInt(input.value, 10);
          if (isNaN(qty) || qty <= 0) return;
          var linePrice = qty * (parseInt(input.dataset.price, 10) || 0);
          discountCents += Math.floor(linePrice * percent / 100);
        });
      }
      var netCents = totalCents - discountCents;

      function discounted(cents) {
        return cents - Math.floor(cents * percent / 100);
      }

      if (unitPriceElement) {
        if (minUnit === null) {
          unitPriceElement.textContent = defaultUnitPriceText;
        } else if (!percent) {
          unitPriceElement.textContent = minUnit === maxUnit
            ? formatWorkstoakMoney(minUnit)
            : formatWorkstoakMoney(minUnit) + ' – ' + formatWorkstoakMoney(maxUnit);
        } else {
          var regular = minUnit === maxUnit
            ? formatWorkstoakMoney(minUnit)
            : formatWorkstoakMoney(minUnit) + ' – ' + formatWorkstoakMoney(maxUnit);
          var reduced = minUnit === maxUnit
            ? formatWorkstoakMoney(discounted(minUnit))
            : formatWorkstoakMoney(discounted(minUnit)) + ' – ' + formatWorkstoakMoney(discounted(maxUnit));
          unitPriceElement.textContent = '';
          var strike = document.createElement('s');
          strike.textContent = regular;
          unitPriceElement.appendChild(strike);
          unitPriceElement.appendChild(document.createTextNode(reduced));
        }
      }

      if (subtotalElement) subtotalElement.textContent = formatWorkstoakMoney(totalCents);

      if (discountRow) {
        discountRow.hidden = !percent;
        if (discountLabelElement) discountLabelElement.textContent = 'B2B-Rabatt ' + percent + ' %';
        if (discountAmountElement) discountAmountElement.textContent = '−' + formatWorkstoakMoney(discountCents);
      }

      if (totalPriceElement) totalPriceElement.textContent = formatWorkstoakMoney(netCents);

      if (discountNoteElement) {
        var note = '';
        if (totalCents > 0 && b2bTiers.length) {
          if (tierState.next) {
            note = 'Noch ' + formatWorkstoakMoney(tierState.next.threshold - b2bCartValue - totalCents) +
              ' bis ' + tierState.next.percent + ' % B2B-Rabatt.';
          } else {
            note = 'Maximaler B2B-Rabatt erreicht.';
          }
          if (percent && b2bCartValue > 0) {
            note += ' Der Rabatt gilt auch für die Artikel, die bereits im Warenkorb liegen.';
          }
          if (percent) note += ' Wird im Warenkorb automatisch abgezogen.';
        }
        discountNoteElement.textContent = note;
        discountNoteElement.hidden = !note;
      }

      if (cartButton) cartButton.disabled = total < 1;

      /* Fix 3: feed the current matrix selection into the B2B preview. */
      b2bPending = root.classList.contains('is-matrix') ? totalCents : 0;
      renderWorkstoakB2B();

      return total;
    }

    function getNativeVariantPicker() {
      return document.querySelector(
        'variant-picker[data-product-id="' + productId + '"]'
      );
    }

    function setNativeOptionVisibility(picker, matrixMode) {
      if (!picker) return;

      picker.classList.add('workstoak-native-color-hidden');
      picker.classList.toggle('workstoak-native-size-hidden', matrixMode);

      var fieldsets = picker.querySelectorAll('[data-fieldset-index]');

      if (fieldsets.length > 0) {
        fieldsets[0].style.setProperty('display', 'none', 'important');
      }

      if (fieldsets.length > 1) {
        fieldsets[1].style.setProperty(
          'display',
          matrixMode ? 'none' : '',
          matrixMode ? 'important' : ''
        );
      }

      if (!picker.dataset.workstoakOptionObserver) {
        var observer = new MutationObserver(function () {
          var currentFieldsets = picker.querySelectorAll('[data-fieldset-index]');

          if (currentFieldsets.length > 0) {
            currentFieldsets[0].style.setProperty('display', 'none', 'important');
          }

          if (currentFieldsets.length > 1) {
            currentFieldsets[1].style.setProperty(
              'display',
              root.classList.contains('is-matrix') ? 'none' : '',
              root.classList.contains('is-matrix') ? 'important' : ''
            );
          }
        });

        observer.observe(picker, { childList: true, subtree: true });
        picker.dataset.workstoakOptionObserver = 'true';
      }
    }

    function syncNativeVariantPicker(matrixMode) {
      var picker = getNativeVariantPicker();
      if (picker) setNativeOptionVisibility(picker, matrixMode);
      return picker;
    }

    function setStickyAddToCartVisibility(matrixMode) {
      document.documentElement.classList.toggle('workstoak-matrix-active', matrixMode);
      document.querySelectorAll('sticky-add-to-cart[data-product-id="' + productId + '"]').forEach(function (sticky) {
        sticky.style.display = matrixMode ? 'none' : '';
      });
    }

    function setMatrixMode(active) {
      root.classList.toggle('is-matrix', active);
      matrix.hidden = !active;

      var picker = document.querySelector(
        'variant-picker[data-product-id="' + productId + '"]'
      );

      if (picker) {
        setNativeOptionVisibility(picker, active);
      }

      var form = document.querySelector(
        'product-form-component[data-product-id="' + productId + '"]'
      );

      if (form) {
        var wrapper = form.closest('.shopify-block') || form.parentElement;
        if (wrapper) wrapper.style.display = active ? 'none' : '';
      }

      setStickyAddToCartVisibility(active);

      if (message) message.textContent = '';
      updateTotals();
    }

    colorButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setSelectedColor(button.dataset.workstoakColor);
      });
    });

    quantities.forEach(function (input) {
      input.addEventListener('input', function () {
        applyQuantityLimit(input, true);
        updateTotals();
      });
      input.addEventListener('change', function () {
        var value = parseInt(input.value, 10);
        if (isNaN(value) || value < 0) input.value = 0;
        applyQuantityLimit(input, true);
        updateTotals();
      });
    });

    if (toggle) {
      toggle.addEventListener('click', function () {
        setMatrixMode(!root.classList.contains('is-matrix'));
      });
    }

    if (cartButton) {
      cartButton.addEventListener('click', function () {
        /* Fix 5: final safety net before sending to Shopify. */
        applyAllQuantityLimits();

        var items = [];

        quantities.forEach(function (input) {
          if (input.disabled) return;
          var quantity = parseInt(input.value, 10);
          if (!isNaN(quantity) && quantity > 0) {
            items.push({
              id: Number(input.dataset.variantId),
              quantity: quantity
            });
          }
        });

        if (!items.length) {
          updateTotals();
          return;
        }

        cartButton.disabled = true;
        if (message) message.textContent = 'Wird zum Warenkorb hinzugefügt …';

        /*
         * Deliberately use Shopify's Ajax Cart API here instead of
         * Shopify.actions.updateCart(). The latter is Storefront API based
         * and can return SFAPI400 on some Horizon configurations. The Ajax
         * Cart API officially supports adding multiple variants in one call.
         */
        async function addMatrixItems() {
          var response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: items,
              sections: 'cart-drawer-section,cart-icon-bubble,cart-live-region-text',
              sections_url: '/cart'
            })
          });

          var data = {};
          try {
            data = await response.json();
          } catch (parseError) {
            data = {};
          }

          if (!response.ok) {
            throw new Error(
              data.description ||
              data.message ||
              'Beim Hinzufügen zum Warenkorb ist ein Fehler aufgetreten (HTTP ' + response.status + ').'
            );
          }

          /*
           * Horizon can react to cart:update. Pass the server-rendered
           * sections along as well, so the cart count/drawer can refresh
           * without a second cart mutation request.
           */
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              data: {
                source: 'product-form-component',
                itemCount: data.item_count,
                productId: root.dataset.productId
              },
              sections: data.sections || {}
            }
          }));

          /* Keep compatibility with older/custom listeners. */
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { cart: data }
          }));

          /* Open the native Horizon cart drawer after the Ajax add. */
          if (
            window.Shopify &&
            Shopify.actions &&
            typeof Shopify.actions.openCart === 'function'
          ) {
            await Shopify.actions.openCart();
          } else {
            var drawer = document.querySelector('cart-drawer-component');
            if (drawer && typeof drawer.open === 'function') drawer.open();
          }

          return data;
        }

        addMatrixItems()
          .then(function () {
            /* Fix 1: always replace the loading text with the success message. */
            if (message) message.textContent = 'Artikel wurden zum Warenkorb hinzugefügt.';
            quantities.forEach(function (input) {
              input.value = 0;
            });
          })
          .catch(function (error) {
            if (message) {
              message.textContent =
                error && error.message
                  ? error.message
                  : 'Beim Hinzufügen zum Warenkorb ist ein Fehler aufgetreten.';
            }
            /* Fix 5: stock may have changed meanwhile – re-read the cart and re-apply limits. */
            updateWorkstoakB2BStatus();
          })
          .finally(function () {
            /* Re-evaluates totals and keeps the button disabled when all quantities are 0. */
            updateTotals();
          });
      });
    }

    syncNativeVariantPicker(false);

    /* Horizon can finish rendering the variant picker after this block
       initializes. Re-apply both option visibility rules. */
    window.setTimeout(function () { syncNativeVariantPicker(root.classList.contains('is-matrix')); }, 50);
    window.setTimeout(function () { syncNativeVariantPicker(root.classList.contains('is-matrix')); }, 250);
    window.setTimeout(function () { syncNativeVariantPicker(root.classList.contains('is-matrix')); }, 750);
    window.setTimeout(function () { syncNativeVariantPicker(root.classList.contains('is-matrix')); }, 1500);

    /* Fix 6: start with the color of the actually selected variant (e.g. ?variant= in the URL)
       without triggering a variant change; jump the gallery instantly. */
    bindGalleryArrows();
    if (colorButtons.length) {
      var initialColor = root.dataset.initialColor;
      if (!getColorButton(initialColor)) initialColor = colorButtons[0].dataset.workstoakColor;
      setSelectedColor(initialColor, { clickNative: false, animate: false });
    }

    applyAllQuantityLimits();
    updateTotals();
    updateWorkstoakB2BStatus();
    document.addEventListener('cart:update', function () { window.setTimeout(updateWorkstoakB2BStatus, 150); });
    document.addEventListener('cart:refresh', function () { window.setTimeout(updateWorkstoakB2BStatus, 150); });
  }

  function initAllWorkstoakSelections() {
    document.querySelectorAll('[data-workstoak-selection]').forEach(
      initWorkstoakSelection
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllWorkstoakSelections);
  } else {
    initAllWorkstoakSelections();
  }

  document.addEventListener('shopify:section:load', initAllWorkstoakSelections);
})();
  } catch(e) { console.error(e); }
})();

})();
